module.exports = __webpack_public_path__ + "assets/stuff-2.19d2a8b2.svg";